import React from 'react';

export default function CompanyModulePicker({ modules, selected, onChange }) {
  const ids = selected.map(Number);
  return <fieldset style={{ border: '1px solid #cbd5e1', borderRadius: 8, padding: 16, margin: '0 0 24px' }}>
    <legend style={{ fontWeight: 600 }}>Assigned Modules</legend>
    <div style={{ display: 'flex', gap: 12, marginBottom: 14, alignItems: 'center' }}>
      <button type="button" onClick={() => onChange(modules.map(module => Number(module.id)))}>Select all modules</button>
      <button type="button" onClick={() => onChange([])}>Clear selection</button>
      <span>{ids.length} selected</span>
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
      {modules.map(module => <label key={module.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
        <input type="checkbox" checked={ids.includes(Number(module.id))} onChange={event => onChange(event.target.checked ? [...ids, Number(module.id)] : ids.filter(id => id !== Number(module.id)))} />
        {module.name}
      </label>)}
    </div>
  </fieldset>;
}
